// extracted by mini-css-extract-plugin
export var container = "_2f-0";
export var error = "_2f-9";
export var label = "_2f-5";
export var light = "_2f-6";
export var md = "_2f-3";
export var sm = "_2f-2";
export var thin = "_2f-8";
export var thinBold = "_2f-7";
export var vertical = "_2f-4";
export var xs = "_2f-1";